import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 px-4 bg-[#111827]" data-id="element-83">
      <div className="max-w-4xl mx-auto" data-id="element-84">
        <FadeIn data-id="element-85">
          <div className="bg-gradient-to-br from-[#0a0e1a] to-[#111827] border border-[#c9a84c]/30 rounded-3xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8 shadow-[0_0_40px_rgba(201,168,76,0.1)] relative overflow-hidden" data-id="element-86">
            {/* Decorative background shield */}
            <ShieldCheckIcon className="absolute -right-10 -bottom-10 w-64 h-64 text-[#c9a84c]/5 pointer-events-none" data-id="element-87" />

            <div className="shrink-0 bg-[#c9a84c]/10 p-6 rounded-full border border-[#c9a84c]/20" data-id="element-88">
              <ShieldCheckIcon className="w-16 h-16 text-[#c9a84c]" data-id="element-89" />
            </div>

            <div className="text-center md:text-left relative z-10" data-id="element-90">
              <h2 className="text-2xl md:text-3xl font-bold text-[#f5f5f5] mb-4" data-id="element-91">
                Garantía de Satisfacción Alfa de 7 Días
              </h2>
              <p className="text-[#9ca3af] text-lg leading-relaxed" data-id="element-92">
                Si en una semana no sientes una mejora notable en tu energía o
                si simplemente crees que esto no es para ti, envíame un correo y
                te devuelvo el 100% de tu dinero.{' '}
                <strong className="text-[#f5f5f5]" data-id="element-93">
                  Sin preguntas, sin resentimientos. El riesgo es todo mío.
                </strong>
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}